import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createStore, applyMiddleware } from "redux";
import rootReducer from "./store/reducers/rootReducer";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import {
  ReactReduxFirebaseProvider,
  getFirebase,
  getFirestore,
} from "react-redux-firebase";
import firebase from "firebase/compat/app";
import "firebase/compat/database";
import "firebase/compat/auth";
import axios from "axios";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
export const app = firebase.initializeApp(firebaseConfig);
export const adminApp = firebase.initializeApp(firebaseConfig, "AdminApp"); // 2nd instance to create a user without being logged in
export const adminAuth = adminApp.auth();
export const db = app.database();
export const auth = app.auth();

if (process.env.REACT_APP_ENV === "local") {
  db.useEmulator("localhost", 9900);
  auth.useEmulator("http://localhost:9099");
}

axios.interceptors.request.use(function (config) {
  config.headers["Totpjwt"] = localStorage.getItem("totpJwt");
  return config;
});

// add axios interceptor on response, when error 403 with content "You need to validate your TOTP token to access this feature", redirect to /totp
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (
      error.response.status === 403 &&
      error.response.data ===
      "TOTP_REQUIRED"
    ) {
      if (window.location.pathname !== "/totp") window.location.href = "/totp";
    }
    return Promise.reject(error);
  }
);

export const apiRoot = process.env.REACT_APP_API_ROOT || "http://localhost:5002";

const store = createStore(
  rootReducer,
  applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore }))
);

const rrfProps = {
  firebase,
  config: {},
  dispatch: store.dispatch,
};

ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <App fb={firebase} />
      <div style={{ width: "0", height: "0" }} id="VG_OVERLAY_CONTAINER"></div>
    </ReactReduxFirebaseProvider>
  </Provider>,
  document.getElementById("root")
);
serviceWorker.unregister();
